import { CIcon } from '~/icons/types'
export const ciBox: CIcon = {
  name: 'box',
  type: 'regular',
  width: 509,
  height: 509,
  paths: [
    {
      d:
        'M139.59 189.995v127.173l114.999 66.994 114.999-66.994V189.995l-114.999-63.637-114.999 63.637zm184.228 8.959-69.229 38.995-69.229-38.995 69.229-38.309 69.229 38.309zM169.59 224.503l69.999 39.429v76.773l-69.999-40.779v-75.423zm99.999 116.202v-76.773l69.999-39.429v75.423l-69.999 40.779z'
    },
    {
      d:
        'm509.469 144.688-76.695-22.436-22.435 76.696 28.793 8.422 8.515-29.106a207.399 207.399 0 0 1 14.771 76.888c0 114.15-92.868 207.019-207.019 207.019-37.634 0-74.475-10.194-106.539-29.48L133.397 458.4c36.733 22.094 78.921 33.771 122.002 33.771 63.31 0 122.83-24.654 167.598-69.421 44.767-44.768 69.421-104.288 69.421-167.598 0-30.744-5.964-61.073-17.421-89.291l26.051 7.62 8.421-28.793z'
    },
    {
      d:
        'M108.884 107.251c39.048-38.685 90.745-59.953 145.672-59.953l.993.003c37.635.176 74.428 10.542 106.399 29.977l15.584-25.635c-36.628-22.266-78.761-34.141-121.843-34.342-.383-.002-.756-.003-1.138-.003-62.882 0-122.078 24.354-166.782 68.642-44.975 44.558-69.906 103.963-70.202 167.271a237.273 237.273 0 0 0 17.022 89.377l-26.032-7.747L0 363.595l76.59 22.792 22.793-76.59-28.754-8.557-8.644 29.045a207.283 207.283 0 0 1-14.418-76.933c.258-55.297 22.035-107.183 61.317-146.101z'
    }
  ]
}
